import { reduxKey } from '../constants';
import { createAction } from 'redux-actions';

export const switchTab = createAction(
  `${reduxKey}.EXTENSION_EMOTE_CHANGE_TAB`,
  tab => ({ tab })
);
